<template>
  <div>

    <ul v-for="item in list" :key="item.id" >
      <slot name="items" :item="item" >

      </slot>
    </ul>

  </div>
</template>

<script>
export default {
  name: "Details",
  data() {
    return{

    }
  },
  created() {

  },
  methods: {

  },
  props: ["list"]
}
</script>

<style lang="less" scoped>

</style>
